<template>
	<div>
		<v-container fluid pt-0 grid-list-xl>
			<br><h3><span>{{record.DatTodayStr}}</span></h3>
			<!-- Totalen -->
			<v-layout row wrap>
				<v-flex class="xl3 lg3 md6 sm6 xs6 stats-widget-v3">
					<stats-card-euro
						icon="bookmark" 
						:title="$t('message.sales')"
						v-model="record.PriceTotal"
						color="primary"
					></stats-card-euro>
				</v-flex>
				<v-flex class="xl3 lg3 md6 sm6 xs6 stats-widget-v3">
					<stats-card-v3
						icon="cloud_download"
						:title="$t('message.customerstickesdone')"
						v-model="record.QtyCustomers"
						color="success"
					></stats-card-v3>
				</v-flex>
				<v-flex class="xl3 lg3 md6 sm6 xs6 stats-widget-v3">
					<stats-card-v3
						icon="cloud_upload"
						:title="$t('message.transactions')"
						v-model="record.QtyTickets"
						color="error"
					></stats-card-v3>
				</v-flex>
				<v-flex class="xl3 lg3 md6 sm6 xs6 stats-widget-v3">
					<stats-card-v3
						icon="insert_chart"
						:title="$t('message.appointments')"
						v-model="record.QtyAppoints"
						color="info"
					></stats-card-v3>
				</v-flex>		
			</v-layout>
			<!-- Sales -->
			<v-layout row wrap>
				<app-card
					:heading="''"
					colClasses="xl6 lg6 md12 sm12 xs12"
					customClasses="mb-0 sales-widget"
				>
				<h3>Afspraken van {{record.DatFromStr}}  &nbsp;&nbsp; tot &nbsp;&nbsp;   {{record.DatToStr}}</h3>
					<sales class="mb-3" :height="320" :record="this.record"></sales>	
					<v-layout class="cart-wrap hidden-xs-only pl-4">
						
						<v-flex d-custom-flex>
							<span class="mr-2"><i class="zmdi zmdi-eye success--text"></i></span>
							<p class="mb-0">
								<span class="d-block fs-14 fw-bold">{{record.QtyAppointsWeek}}</span>
								<span class="d-block fs-12 grey--text">Afspraken</span>
							</p>
						</v-flex>
						<v-flex d-custom-flex>
							<span class="mr-2"><i class="zmdi zmdi-equalizer error--text"></i></span>
							<p class="mb-0">
								<span class="d-block fs-14 fw-bold">{{record.QtyOnlineAppointsWeek}}</span>
								<span class="d-block fs-12 grey--text">Online afspraken deze week</span>
							</p>
						</v-flex>
					</v-layout>				
				</app-card>
				
				<app-card
					:heading="$t('message.appointmentchanges')"
					colClasses="xl6 lg6 md12 sm12 xs12"
					customClasses="mb-0">
					
						<v-data-table :items="record.AppsCust" v-bind:headers="headersAppoints" hide-actions disable-initial-sort>
							
							<template slot="items" slot-scope="props">
								<td>{{ props.item.DateModify }}</td>
								<td>{{ props.item.DateInfo }}</td>
								<td>{{ props.item.Information }}</td>
								<td>{{ props.item.Descr }}</td>
							</template>
						</v-data-table>

				</app-card>

			</v-layout>
			<!-- transacties -->
			<v-layout row wrap>
				<!-- Customer Overview -->
				
				<!-- Invoices -->
				<app-card
					:heading="$t('message.transactions')"
					colClasses="xl6 lg6 md12 sm12 xs12"
					customClasses="mb-0"
					>
						<v-data-table :items="record.Tickets" v-bind:headers="headersTrans" hide-actions disable-initial-sort>
							
							<template slot="items" slot-scope="props">
								<td>{{ props.item.DatStr }}</td>
								<td>{{ props.item.CustomerName }}</td>
								<td class="text-xs-right">&euro;{{ props.item.Price.toFixed (2) }}</td>
							</template>
						</v-data-table>

				</app-card>

				<!--<v-btn color="default" @click="printit" name="btncancel" >Print</v-btn>-->
			</v-layout>
		</v-container>
	</div>
</template>

<script>
// charts component
// components
import StatsCardV3 from "Components/StatsCardV3/StatsCardV3";
import StatsCardEuro from "Components/StatsCardEURO/StatsCardEuro";
import StatsCardV4 from "Components/StatsCardV4/StatsCardV4";
import Sales from "Components/Dashboard/AppointmentChart";
import DeviceShare from "Components/Widgets/DeviceShare";
import Invoice from "Components/Widgets/Invoice";
import myHttpApi from "../../api/myHttpApi";

import Printd from "printd"

export default {
  components: {
	StatsCardV3,
	StatsCardV4,
	StatsCardEuro,
	Sales,
	Invoice,
	DeviceShare
  },
  data() {
    return {
	  dateRegister: "",
	  record : {},
	  headersTrans: [
        { text: "Datum"},
		{ text: "Klant"},
		{ text: "Bedrag"}
	  ],
	   headersAppoints: [
        { text: "Datum wijziging"},
		{ text: "Afspraakdatum"},
		{ text: "Klant"},
		{ text: "Behandeling"}
      ],
    };
  },
   mounted() {
	this.dateRegister =  new Date().getDay() + "/" + new Date().getMonth() + "/"+ new Date().getFullYear();
	this.getRemoteData();

	
  },
  methods: {
	printit () {
		var p = new Printd();
		p.print(this.$el, `.my_style { color: blue; }`);
	},
    getRemoteData() {
      myHttpApi
		myHttpApi.post( 'BODashboard/Get', null)
        .then(response => {
			this.record = response.data;
			this.record.PriceTotal = record.PriceTotal.toFixed (2);
        })
        .catch(error => {
          console.log(error);
        });
	}
  }
};
</script>
